import { useEffect } from 'react';
import './neonverse.css';
import { NEONVERSE } from './constants';
import NeonNav from './components/NeonNav';
import NeonHero from './components/NeonHero';
import NeonAbout from './components/NeonAbout';
import NeonDifference from './components/NeonDifference';
import NeonServices from './components/NeonServices';
import NeonStyles from './components/NeonStyles';
import NeonPersonalization from './components/NeonPersonalization';
import NeonHowItWorks from './components/NeonHowItWorks';
import NeonPricing from './components/NeonPricing';
import NeonFAQ from './components/NeonFAQ';
import NeonWhyChoose from './components/NeonWhyChoose';
import NeonContact from './components/NeonContact';
import NeonFooter from './components/NeonFooter';

const NeonVersePage = () => {
  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl?.getAttribute('content') ?? '';

    document.title = NEONVERSE.seoTitle;
    descEl?.setAttribute('content', NEONVERSE.seoDescription);
    window.scrollTo(0, 0);

    return () => {
      document.title = prevTitle;
      descEl?.setAttribute('content', prevDesc);
    };
  }, []);

  return (
    <div className="neonverse">
      <NeonNav />
      <main>
        <NeonHero />
        <NeonAbout />
        <NeonDifference />
        <NeonServices />
        <NeonStyles />
        <NeonPersonalization />
        <NeonHowItWorks />
        <NeonPricing />
        <NeonFAQ />
        <NeonWhyChoose />
        <NeonContact />
      </main>
      <NeonFooter />
    </div>
  );
};

export default NeonVersePage;
